
import Button from "keycloak-theme/Button";
import Input from "keycloak-theme/Input";
import Wrapper from "keycloak-theme/Wrapper";
import './keycloak-theme/KcApp.css';


const Test = ({ }) => {
    return (
        <Wrapper link={"app.stage.datoin.com"} headerNode={<p>Login Setup</p>}>
                <p className="password"><b>Note : </b>Password should be minimum 10 chars in length with at least 1 char each for a digit, special char, uppercase and a lowercase letter</p>
  
            <Input
                tabIndex={1}
                html={true}
                id={'name'}
                name={"user"}
                defaultValue={""}
                type="text"
                otherProps={null}
                label={' Enter your userName or email address'}
                placholder={""}
                htmlFor={'name'}
            />

            <Input
                tabIndex={1}
                html={true}
                id={'password'}
                name={'password'}
                defaultValue={""}
                type="text"
                otherProps={null}
                label={'Enter your password'}
                placholder={""}
                htmlFor={'password'}
            />
                       
  <Button value={"Send Change Password Link"} />

          
        </Wrapper>

    )
}

export default Test